const validatorResult = (
    valid=false,
    message=[]
) => {
    return {
        valid:valid,
        message:message
    }
}

export default validatorResult;